// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsb7vkz{width:1pc}\n._4t3i1tcg{height:24px}\n._syazdgkc{color:var(--ds-icon-subtle,#505258)}", ""]);
// Exports
module.exports = exports;
